import { customAxios } from './customAxios'

export function closePratica(idPratica){
    const config = {
        headers: {
            "AuthToken": JSON.parse(localStorage.getItem('token'))
        }
    } 

   const closePraticaRequest = 
            customAxios.post(process.env.REACT_APP_BACKEND_HOST + "/"+process.env.REACT_APP_PATH_NEW_PREFIX+"/closePratica?idPratica="+idPratica,null,config)
   return closePraticaRequest





}